//base url
// export const baseURL = "http://d4a981714947.ngrok.io";
export const baseURL = process.env.REACT_APP_API_BASE_URL || "https://apps.ng.kpmg.com/NigeriaEthicsAPI";

//endpoints 
export const endpoints = {
    submitIncident: "api/reportIncident",
    getFeedback: "api/getFeedback",
    getMetaData: "api/getAll"
};
